import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import {
  formatCurrency,
  formatDate,
  formatLongCurrency,
  formatNumber,
  identifyLogrocket,
  identifySentry,
} from './utils/functions'

import permission from '@/plugins/permissions'
import services from '@/plugins/services'
import VueCompositionApi from '@vue/composition-api'
import utils from './plugins/utils'
import format from './plugins/format'
import alertDialog from './plugins/alertDialog'
import toast from './plugins/toast'

Vue.use(permission)
Vue.use(alertDialog)
Vue.use(utils)
Vue.use(format)
Vue.use(services)
Vue.use(toast)
Vue.use(VueCompositionApi)

Vue.config.productionTip = false

if (process.env.NODE_ENV !== 'development') {
  if (store.getters.profile && store.getters.profile.role === 'ADMIN') {
    identifyLogrocket(store.getters.profile)
  }

  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new VueIntegration({ Vue, attachProps: true })],
    environment: process.env.VUE_APP_BRANCH,
    release: 'recargaya' + process.env.VUE_APP_VERSION,
  })
  identifySentry()
}

Vue.filter('number', (value: number | string) => formatNumber(value))
Vue.filter('currency', (value: number | string) => formatCurrency(value))
Vue.filter('longCurrency', (value: number | string) =>
  formatLongCurrency(value),
)
Vue.filter('dateTime', (value: string) => formatDate(value))
Vue.filter('shortDateTime', (value: string) =>
  formatDate(value, 'MMM DD YYYY, hh:mm a'),
)
Vue.filter('time', (value: string) => formatDate(value, 'hh:mm a'))
Vue.filter('shortDate', (value: string) => formatDate(value, 'MMM DD YYYY'))

store
  .dispatch('refreshToken')
  .then(async response => {
    if (!response) {
      store.state.accessToken = ''
    } else {
      await store.dispatch('getProfileInfo')
    }
  })
  .finally(() => {
    store.state.initialized = true
    new Vue({
      router,
      store,
      vuetify,
      i18n,
      render: h => h(App),
    }).$mount('#app')
  })
